module.exports = __webpack_public_path__ + "img/CA_mcgeorge2.f1b2346.png";